import _ from '@lodash';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { TextField, InputAdornment } from '@material-ui/core';
import { Lock } from '@material-ui/icons';
import { useIMask } from 'react-imask';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { determineEditableAccess } from '../EditFormUtils';

function EditFormTextField(props) {
	const methods = useFormContext();
	const { t } = useTranslation(props.config.topic ? ['editform', props.config.topic] : 'editform');
	const { error } = props.fieldState;
	const { value, onChange } = props.field;
	const { ref, maskRef } = useIMask(props.fieldConfig.mask);
	const [readOnly, setReadOnly] = useState(determineEditableAccess(props.config, props.fieldConfig, props.fieldPrefix));

	const isNumber = props.fieldConfig.type === 'number';
  	const isMsToSec = props.fieldConfig.unitConversion === 'msToSecond' && isNumber;

	const displayValue = (() => {
		if (value === null || value === undefined || Number.isNaN(value)) return '';
		if (!isMsToSec) return value;
		const n = Number(value);
		return Number.isFinite(n) ? String(n / 1000) : '';
	})();

	const handleChange = (e) => {
		const raw = e?.target?.value;
		if (raw === '' || raw == null) { onChange(null); return; }

		if (!isNumber) { onChange(raw); return; }

		const n = Number(raw);
		if (!Number.isFinite(n)) return;

		onChange(isMsToSec ? n * 1000 : n);
	};

	const handleOnBlur = () => {
		if (!_.isUndefined(props.fieldConfig.autoCapitalize) && _.isString(value)) {
			let newValue = value;
			if (props.fieldConfig.autoCapitalize === 'upper') {
				newValue = newValue.toUpperCase();
			} else if (props.fieldConfig.autoCapitalize === 'lower') {
				newValue = newValue.toLowerCase();
			} else if (props.fieldConfig.autoCapitalize === 'capitalize') {
				newValue = newValue
					.split(' ')
					.map(s => (s.length > 0 ? s[0].toUpperCase() + s.slice(1) : ''))
					.join(' ');
			}
			if (newValue !== value) {
				onChange(newValue);
			}
		}
	};

	useEffect(() => {
		!_.isUndefined(props.fieldConfig.onChange) ? props.fieldConfig.onChange(value, props.field, methods) : null;
	}, [value]);

	// Handle value conversion for number fields
	const inputValue = value === null || value === undefined || Number.isNaN(value) 
		? '' 
		: value;

	return (
		<TextField
			{...props.field}
			value={displayValue}
      		onChange={handleChange}
			className={clsx('mt-8 mb-16', props.fieldConfig.className)}
			type={props.fieldConfig.type ? props.fieldConfig.type : 'text'}
			error={error}
			required={props.fieldConfig.required}
			helperText={error ? error.message : props.fieldConfig.helperText}
			label={!_.isUndefined(props.fieldConfig.text) ? props.fieldConfig.text : t(`${props.config.topic}:${props.fieldConfig.key}`)}
			id={props.field.name}
			variant="outlined"
			fullWidth
			multiline={props.fieldConfig.multiline || false}
			autoComplete={props.fieldConfig.autoComplete || 'on'}
			inputRef={ref}
			InputProps={{
				maxLength: props.fieldConfig.maxLength || null,
				readOnly,
				startAdornment: props.fieldConfig.startAdornment,
				endAdornment: readOnly ? (
					<InputAdornment position="end">
						<Lock fontSize="small" color="disabled" />
					</InputAdornment>
				) : (
					isMsToSec ? <InputAdornment position="end">s</InputAdornment> : props.fieldConfig.endAdornment
				)
			}}
			onBlur={() => handleOnBlur()}
			inputMode={isNumber ? 'decimal' : undefined}
		/>
	);
}

export default EditFormTextField;
